module.exports = "https://cdn.thelire.com/ins/resource/lh_store_vip_follower.7fc1d1481d4531c7439bf5e96a2db4a2.png";